export default {
    NavData:[]
}